import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompleteSortieCommand } from '@flyfreely-portal-ui/flyfreely';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MissionRecordService } from '../../../mission-record-edit/mission-record.service';
import {
    DisplayableResource,
    MissionCompletionService
} from '../../mission-completion.service';

@Component({
    selector: 'assign-to-flight-dialogue',
    template: `
        <div class="input-group" style="min-width: 250px;">
            <ng-select
                [items]="allFlights"
                [(ngModel)]="selectedFlight"
                bindValue="id"
                (click)="$event.stopPropagation()"
            >
                <ng-template ng-option-tmp let-item="item">
                    {{ getFlightLabel(item) }}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    {{ getFlightLabel(item) }}
                </ng-template>
            </ng-select>
            <button
                type="button"
                class="btn btn-primary pull-right top-buffer"
                (click)="assignToFlight.emit(selectedFlight)"
                [disabled]="selectedFlight == null"
            >
                Assign
            </button>
        </div>
    `
})
export class AssignToFlightDialogue {
    @Input() historicalMission: boolean;
    @Output() assignToFlight = new EventEmitter<number>();

    allFlights: CompleteSortieCommand[] = [];
    selectedFlight: number;

    availablePersonnel: DisplayableResource[] = [];

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private missionCompletionService: MissionCompletionService,
        private missionRecordService: MissionRecordService
    ) {}

    ngOnInit() {
        this.refreshLists();
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    refreshLists() {
        if (this.historicalMission) {
            this.allFlights =
                this.missionRecordService.form.controls.flights.value ?? [];

            this.missionRecordService.form.controls.flights.valueChanges
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(flights => (this.allFlights = flights));

            combineLatest([
                this.missionRecordService.availablePersonnel$,
                this.missionRecordService.selectedPilots$
            ])
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(
                    ([personnel, selectedPilots]) =>
                        (this.availablePersonnel =
                            personnel.concat(selectedPilots))
                );
        } else {
            this.allFlights =
                this.missionCompletionService.form.controls.flights.value ?? [];

            this.missionCompletionService.form.controls.flights.valueChanges
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(flights => (this.allFlights = flights));

            combineLatest([
                this.missionCompletionService.availablePersonnel$,
                this.missionCompletionService.selectedPilots$
            ])
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(
                    ([personnel, selectedPilots]) =>
                        (this.availablePersonnel =
                            personnel.concat(selectedPilots))
                );
        }
    }

    getFlightLabel(flight: CompleteSortieCommand) {
        const flightNumber = `Flight ${flight.number}`;
        const pilot = this.availablePersonnel.find(
            p => p.id === flight.pilotId
        );
        const pilotDetails = pilot != null ? `, RP - ${pilot.name}` : '';
        return flightNumber + pilotDetails;
    }
}
